import {createAction, props} from '@ngrx/store';

export const TRACK_ARTICLE = '[Blog Article] Track Article';
export const TRACK_ARTICLE_SUCCESS = '[Blog Article] Track Article Success';
export const TRACK_ARTICLE_FAILURE = '[Blog Article] Track Article Failure';

export const trackArticle = createAction(
  TRACK_ARTICLE,
  props<{ resource: string }>()
)

export const trackArticleSuccess = createAction(
  TRACK_ARTICLE_SUCCESS
)

export const trackArticleFailure = createAction(
  TRACK_ARTICLE_FAILURE,
  props<{ error: string }>()
)
